import { render, staticRenderFns } from "./keylist.vue?vue&type=template&id=20bb2b06&scoped=true"
import script from "./keylist.vue?vue&type=script&lang=js"
export * from "./keylist.vue?vue&type=script&lang=js"
import style0 from "./keylist.vue?vue&type=style&index=0&id=20bb2b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb2b06",
  null
  
)

export default component.exports